<mat-card [class.highlighted]="isSelected"
          class="calendar-item-container">
    <mat-card-content [formGroup]="formGroup">
        <mat-form-field [refocus]="isSelected"
                        [uiAutofocus]="isSelected">
            <input [uiAuthorizeDisable]="calendar.newEntry ? 'Settings.Create' : 'Settings.Edit'"
                   [value]="calendar.calendarName"
                   [matTooltip]="calendar.calendarName"
                   (keyup.enter)="completeEdit()"
                   (keyup.esc)="onEscape()"
                   (focus)="focus.emit()"
                   formControlName="name"
                   matInput
                   data-cy="calendar-item-input">
            <mat-error [matTooltip]="'settings_calendar_name_invalid_warning' | translate"
                       translate>
                settings_calendar_name_invalid_warning
            </mat-error>
        </mat-form-field>
        <div class="action-buttons">
            <button [class.calendar-item-indicator-open]="isSelected"
                    mat-icon-button
                    class="calendar-item-indicator"
                    type="button">
                <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
        </div>
    </mat-card-content>
</mat-card>
